module.exports = __webpack_public_path__ + "aa09ec9bd0a134d5376a5a4375da02d6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/font_uzv8nkw1nabgldi.ttf
// module id = 1820
// module chunks = 0